import { render, staticRenderFns } from "./GameSearchItem.vue?vue&type=template&id=98211912"
import script from "./GameSearchItem.vue?vue&type=script&lang=js"
export * from "./GameSearchItem.vue?vue&type=script&lang=js"
import "./GameSearchItem.vue?vue&type=style&index=0&id=98211912&prod&lang=scss"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports